/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.HtmlContent";
        class HtmlContentWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("HtmlContentWidgetTypeClass.createInstance()");
                    return new HtmlContentWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("HtmlContentWidgetTypeClass._storeHtml()");
                    HtmlContentWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("HtmlContentWidgetTypeClass::constructor");
                this._allowedOnLogon = true;
                if (HtmlContentWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/HtmlContent/html-content.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.HtmlContentWidgetTypeClass = HtmlContentWidgetTypeClass;
        class HtmlContentWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._iframe = null;
                this._loader = null;
                this._refreshButton = null;
                this._refreshTriggers = null;
                this._suppressLoaderOnRefresh = false;
                this._urlMode = null;
                this._lastQuery = null;
                this._lastFlex = null;
                this._lastURL = null;
                this._usageAllowed = true;
                this.presentInstance = () => {
                    this._log.info("HtmlContentWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = HtmlContentWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._iframe = this._container.querySelector('#htmlContent');
                    this._loader = this._container.querySelector('#htmlContentSearchLoader');
                    this._refreshButton = this._container.querySelector('#htmlContentReload');
                    this._core.Helper.prepareWptLoader(this._loader, 'wpt-font wpt-font-icon_Search');
                    this._widgets.setTitle(this._config, this._container.querySelector('#htmlContentWidgetTitle'), 'STR_WPT_HTML_CONTENT');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslationAttribute(this._refreshButton, 'title', 'STR_WPT_REFRESH');
                    this._refreshButton.addEventListener('click', this._refreshContent);
                    let config = this._config;
                    if (config.hasOwnProperty('SuppressLoaderOnRefresh') && (config.SuppressLoaderOnRefresh != null))
                        this._suppressLoaderOnRefresh = config.SuppressLoaderOnRefresh;
                    if (config.hasOwnProperty('Height')) {
                        this._iframe.height = config.Height + "px";
                    }
                    if (this._usageAllowed) {
                        if (config.hasOwnProperty('URL')) {
                            this.updateURL(config.URL);
                        }
                        else if (config.hasOwnProperty('Query')) {
                            this.updateSearch(config.Query);
                        }
                        else if (config.hasOwnProperty('FlexQuery')) {
                            this.updateSearchWithFlex(config.FlexQuery);
                        }
                    }
                    if (config.hasOwnProperty('RefreshTriggers') && config.RefreshTriggers && (config.RefreshTriggers.length > 0))
                        this._refreshTriggers = config.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("HtmlContentWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("HtmlContentWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this.updateURL = (url) => {
                    this._log.info("HtmlContentWidgetInstanceClass.updateURL()");
                    this._iframe.innerHTML = "";
                    this._iframe.removeAttribute('srcdoc');
                    this._iframe.src = this._core.Context.applyAllMacros(url);
                    this._urlMode = true;
                    this._lastURL = url;
                };
                this.updateSearch = (query, refreshing = false) => {
                    this._log.info("HtmlContentWidgetInstanceClass.updateSearch()");
                    this._clearErrors();
                    this._iframe.innerHTML = "";
                    this._iframe.src = "";
                    this._iframe.srcdoc = "";
                    if (!refreshing || this._suppressLoaderOnRefresh)
                        this._showLoader();
                    this._urlMode = false;
                    this._lastQuery = query;
                    let requestSearch = this._core.OBHelper.compileFlexSearchFromQueryDef(query);
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._displayResult, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this.updateSearchWithFlex = (searchDef, refreshing = false) => {
                    this._log.info("HtmlContentWidgetInstanceClass.updateSearchWithFlex()");
                    this._iframe.innerHTML = "";
                    this._iframe.src = "";
                    this._iframe.srcdoc = "";
                    if (!refreshing || this._suppressLoaderOnRefresh)
                        this._showLoader();
                    this._urlMode = false;
                    this._lastFlex = searchDef;
                    let requestSearch = this._core.OBHelper.flexDefinitionToRequest(searchDef);
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._displayResult, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._showLoader = () => {
                    this._log.info("HtmlContentWidgetInstanceClass._showLoader()");
                    let height = this._iframe.offsetHeight;
                    let width = this._iframe.offsetWidth;
                    let minValue = Math.min(height, width);
                    let fontValue = minValue / 3; // HACK: based on style for loader
                    this._loader.style.fontSize = fontValue + "px";
                    this._core.Functions.showElement(this._loader);
                };
                this._displayResult = (response) => {
                    this._log.info("HtmlContentWidgetInstanceClass._displayResult()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        let doc = response.Documents[0];
                        let url = '/OnBaseDocument.ashx?wmode=transparent&id=' + doc.ItemNum;
                        this._core.Loader.genericServiceCallTextData(url, this._displayDocument, this._callErrorHandler);
                    }
                    else {
                        console.warn("no documents received");
                        this._core.Functions.hideElement(this._loader);
                    }
                };
                this._displayDocument = (textData) => {
                    this._log.info("HtmlContentWidgetInstanceClass._displayDocument()");
                    this._core.Functions.hideElement(this._loader);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    if (textData.ContentType == 'text/html') {
                        this._iframe.srcdoc = textData.ContentText;
                    }
                    else {
                        console.warn("unsupported content type: " + textData.ContentType);
                    }
                };
                this._refreshContent = () => {
                    this._log.info("HtmlContentWidgetInstanceClass._refreshContent()");
                    if (this._urlMode) {
                        if (this._lastURL)
                            this.updateURL(this._lastURL);
                    }
                    else if (this._lastQuery)
                        this.updateSearch(this._lastQuery);
                    else if (this._lastFlex)
                        this.updateSearchWithFlex(this._lastFlex);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("HtmlContentWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                if (!core.isUserLoggedIn() && !config.hasOwnProperty('URL') && config.hasOwnProperty('Query')) {
                    let msg = core.Locale.getTranslation('STR_WPT_LOGON_NOT_ALLOWED_SETTING') + ": Query";
                    this.addError(msg);
                    this._usageAllowed = false;
                }
            }
            activate(context) {
                this._log.info("HtmlContentWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                if (this._refreshTriggers.length > 0) {
                    // Loop with iterator so we can escape when necessary
                    for (let i = 0; i < this._refreshTriggers.length; i++) {
                        let trigger = this._refreshTriggers[i];
                        if (this._core.Functions.triggerEventMatches(trigger, context)) {
                            this._refreshContent();
                            // Only trigger once
                            return;
                        }
                        else {
                            continue;
                        }
                    }
                }
            }
        }
        HtmlContentWidgetInstanceClass.HtmlData = null;
        Widgets.HtmlContentWidgetInstanceClass = HtmlContentWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
